export default {
    buttons: {
        search: 'Search',
        choose: 'Choose',
        chosen: 'Chosen',
        close: 'Close',
        show: 'Show',
        save: 'Save',
    },

    property_type: {
        unit: 'Unit',
        building: 'Building',
        parcel: 'Parcel',
        flat: 'Flat',
        family_house: 'Family house',
        recreational: 'Recreational object',
        apartment_house: 'Apartment house',
        hut: 'Hut',
        cottage: 'Cottage',
        land: 'Land',
    },

    data: {
        all_data: 'All data',
        purchased_only: 'Purchased only',
    },

    parameters: {
        district: 'District',
        village: 'Village',
        cadastre_area: 'Cadastre area',
        period: 'Period',
        unit_usage: 'Unit usage type',
        building_usage: 'Building usage type',
        land_type: 'Land type',
        share_area: 'Area by share',
        parcel_under: 'Parcel under the building',
        parcel_area: 'Parcel area',
        by_pairing: 'According to pairing',
        paired: 'Paired',
        to_pair: 'To be paired',
        without_candidates: 'Without candidates',
        area_size: 'Area size',
        countable_area: 'Countable area',
        age: 'Age',
        land_area: 'Land area',
        form: {
            names: {
                ownership: "Ownership",
                disposition: "Disposition",
                construction: "Construction",
                floor: "Apartment floor",
                total_floors: "Total floors",
                rating: "Property condition",
                land_type: "Land type",
                building_type: "Typ stavebního objektu",
                subcategory: "Subcategory",
                construction_quality: "Quality of construction",
            },

            rating: {
                bad: 'Uninhabitable',
                nothing_much: 'Before reconstruction',
                good: 'Average',
                very_good: 'Very good',
                new: 'New construction',
                excellent: 'Luxurious',

                help: {
                    flat: {
                        bad: 'An apartment in which it is impossible to live without complete reconstruction. The bathroom and the kitchen are missing.',
                        nothing_much: 'An apartment in which it is impossible to live without complete reconstruction. The bathroom and kitchen are missing. It is possible to live here, but the bathroom and kitchen are min. 25 years old and would deserve to be modernized. These are, for example, panel apartments with a umakarta core.',
                        good: 'The kitchen and bathroom are in such a condition that they can be fully used without major modifications. However, they are not after complete reconstruction in recent years.',
                        very_good: 'The apartment has been completely renovated (kitchen, bathroom, windows).',
                        new: 'Normal new construction or almost new property. The price should be similar to other new buildings in the area.',
                        excellent: 'Very expensive technologies and materials are used. The price should be much higher than the usual new buildings in the area.'
                    },

                    house: {
                        bad: 'The house is intended for demolition or complete reconstruction (roof, windows, facade, kitchen, bathroom).',
                        nothing_much: 'No reconstruction has taken place here for at least 25 years. The interior and exterior deserve modernization.',
                        good: 'The house can be used comfortably. However, the interior or exterior has not undergone any renovation in recent years.',
                        very_good: 'The house has been completely renovated (roof, windows, facade, kitchen, bathroom).',
                        new: 'Normal new construction or almost new property. The price should be similar to other new buildings in the area.',
                        excellent: 'Very expensive technologies and materials are used. The price should be much higher than the usual new buildings in the area.'
                    },
                },
            },

            land_type: {
                null: 'Not listed',
                building: 'Building',
                field: 'Field',
                garden: 'Garden',
                meadow: 'Meadow',
                forest: 'Forest',
                other: 'Other',
            },

            house_subtype: {
                unified_panel: 'Panel',
                unified_other: 'Typical',
                atypical: 'Non-typical',
                individual: 'Individual',
                semi_detached: 'Semi detached',
                row_house: 'Row house',
                hut: 'Hut',
                cottage: 'Cottage',
                help: {
                    unified_panel: 'A classic 20th century prefabricated apartment building, the structure of which is assembled from prefabricated reinforced concrete parts.',
                    unified_other: 'Residential buildings that are repetitive in construction (have a given type, a floor plan that is repeated several times, or is only slightly modified based on the customers wishes). The construction system is any except prefabricated construction E.g. a large development project where 2 types of apartment building are used which are repeated several times on the plot',
                    atypical: 'Residential buildings that have a unique shape and floor plan (are built only once). The construction system is any but prefabricated.',
                    individual: 'It is a detached single family house.',
                    semi_detached: 'A detached house that shares one common wall with the house next door.',
                    row_house: 'A family house that is arranged in a row close together and shares a load-bearing wall with the adjacent house.',
                    hut: 'A building that is intended for individual recreation. It may have a basement and no more than one storey and an attic.',
                    cottage: 'A building which is intended not only for recreation but also for possible year-round living.',
                }
            },

            floors: {
                basement: "Basement",
                first_floor: "Ground floor",
                floor: "floor",
            },

            ownership: {
                null: 'Not listed',
                private: 'Private',
                cooperative: 'Cooperative',
                council: 'State/municipal',
                other: 'Other',
            },

            local_type: {
                null: 'Not listed',
                '1+kk': '1+kk',
                '1+1': '1+1',
                '2+kk': '2+kk',
                '2+1': '2+1',
                '3+kk': '3+kk',
                '3+1': '3+1',
                '4+kk': '4+kk',
                '4+1': '4+1',
                'jiné': 'other',
            },

            constructions: {
                null: 'Not listed',
                brick: 'Brick',
                wood: 'Wood',
                stone: 'Stone',
                montage: 'Montage',
                monolithic_bar: 'Monolithic',
                monolithic_panel: 'Panel',
                not_specified: 'Not specified',
                panel: 'Panel',
                prefabricated: 'Prefabricated',
                mixed: 'Mixed',
                low_energy: 'Low energy',
                other: 'Other',
            },

            construction_quality: {
                standard: 'Standard',
                low: 'Low',
                high: 'High',
                very_high: 'Very high',
                help: {
                    standard: 'It contains basic elements, <strong>no extra equipment</strong>. Standard materials, classic equipment (1x bathroom and toilet), classic type of plastered facade with insulation. Roof composed of tiles (ceramic, concrete) or metal.',
                    low: 'The materials and equipment used in the building <strong>are of low quality</strong>. The building does not contain elements that are described in the standard material equipment. The low standard of material can be recognized by visual inspection. It is related to the quality of the materials and the quality of the workmanship (a greater number of incompletions, complaints and errors). It also contains elements that prevent the <strong>problem-free use of the building.',
                    high: '<strong>It contains some of the following elements</strong>: balcony, loggia, terrace, pantry, cellar, laundry, common areas. There are more than one toilet or bathroom (e.g. 2x toilets and includes a shower and bath). The <strong> materials used are of superior quality </strong> (large format tiles, designer switches/sockets, large format windows, PVC foil roofing).',
                    very_high: '<strong>Includes some of the elements from the previous standard plus some of the following elements</strong>: fireplace, sauna, swimming pool, central vacuum cleaner, underfloor heating, air conditioning, electric blinds and shutters, tiles and decorative elements (stone tiles, exposed concrete, stainless steel elements, mosaics, wooden parquet). It also includes the external equipment of the building: solar panels, rainwater management tanks, ventilated facades (green, metal, wooden), roof (green, copper, shingle, slate, sloping, sliding).',
                },
            },
        },
    },

    titles: {
        property_type: 'Type of property',
        address: 'Address',
        sale_lease: 'Sale or lease',
        more: 'Property details',
        disposition: 'Disposition',
        as_of: 'Calculate estimate as of date',
    },

    kind: {
        sale: 'Sale',
        lease: 'Lease',

        help: {
            sale: 'I want to know the current usual price of this property',
            lease: 'I want to know the current usual rental price for this property',
        }
    },

    autocomplete: {
        placeholder: "Address or coordination in format 50.1000593, 13.4360036",
        no_result: "No result found",
        loading: "Loading...",
    },

    disposition: {
        floor_area: "Floor area",
        lot_area: "Lot area",
        balcony: "Balcony + Loggia + Terrace",
        garden: "Own garden",
        cellar: "Cellar",
        garage: "Garage",
        other_area: "Other area",

        help: {
            floor_area: 'In Valuo, the floor area is the sum of all rooms WITHOUT all vertical load-bearing and non-load-bearing structures inside the apartment, such as walls, columns, pillars, chimneys and similar vertical structures.',floor_area_other: 'The floor area in Valuo, compared to Government Regulation No. 366/2013 Sb., is considered as the sum of all rooms EXCLUDING all vertical load-bearing and non-load-bearing structures inside the object, such as walls, columns, pillars, chimneys, and similar vertical structures.',
            floor_area_flat: 'The floor area in Valuo, compared to Government Regulation No. 366/2013 Sb., is considered as the sum of all rooms EXCLUDING all vertical load-bearing and non-load-bearing structures within the apartment, such as walls, columns, pillars, chimneys, and similar vertical structures.',
            flat_reproduction_price: 'The reproduction price is calculated for the whole building, therefore it cannot be determined for a specific housing unit. If you need to find out the price of the apartment for insurance, use our market price calculation.'
        }
    },

    custom_area: {
        title: 'Custom area',
        modal_btn: 'Custom area',
        remove: 'Remove',
        add: 'Add custom area',
        save: 'Save custom area',
        close: 'Close',
        types: {
            kitchen: 'Kitchen',
            living_room: 'Living room',
            kitchen_w_living_room: 'Living room with kitchen',
            bedroom: 'Bedroom',
            children_room: 'Children\'s room',
            bathroom: 'Bathroom',
            toilet: 'Toilet',
            hallway: 'Hallway',
            gallery: 'Gallery',
            dressing_room: 'Dressing room',
            other: 'Other',
            flat_technical_room: 'Flat technical room',
            technical_room: 'Technical room',
            workshop: 'Workshop',
            uninhabited_attic: 'Uninhabited attic',
        }
    },

    reproduction: {
        flat_price: 'Reproduction price of the apartment',
        find_price: 'Find out the market price',
        market_price: 'Calculation of the market price',
        reproduction_price: 'Calculation of the reproduction price',
    },

    prepositions: {
        of: 'of',
        in: 'in',
        from: 'from',
        to: 'to',
    },

    result: '0 results | {n} result | {n} results | {n} results',

    record_search: {
        btn: 'Select by parameters',
        modal_title: 'Selection of parameters and properties',
        search_results_count: 'More than {n} results found. Refine the selection.',
        btn_back: 'Back to parameter selection',
        table: {
            area: 'Area',
            price: 'Price',
            pairing_status: 'Sale pairing',
        }
    },

    coefficients: {
        valued: 'Valued property',
        comparable: 'Comparable property',
        better: 'Better',
        same: 'Same',
        title_valued: 'The valued property is better',
        title_comparable: 'The comparable property is better',
        difference: 'Difference',
        delete_custom_coef: 'Delete item',
        create_custom_coef: 'Add another item',
        edit_advertised_price: 'Advertised price adjustment',
        original_price: 'Original price',
        final_price: 'Final price adjustment',
        edit_price: 'Adjusted price',
    },

}
